import { render, staticRenderFns } from "./SectionPostAndImage.vue?vue&type=template&id=18a55636&"
import script from "./SectionPostAndImage.vue?vue&type=script&lang=js&"
export * from "./SectionPostAndImage.vue?vue&type=script&lang=js&"
import style0 from "./SectionPostAndImage.vue?vue&type=style&index=0&id=18a55636&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
